<template>
  <v-timeline-item right fill-dot icon="flare" color="purple">
    <span slot="opposite">{{data.generator}}</span>
    <span>{{data.text}}</span>
  </v-timeline-item>
</template>

<script>
export default {
  name: 'Gimme',
  props: {
    data: Object
  }
}
</script>

<style scoped>
.gimme {
  border: 1px solid red;
  margin: 2px;
  background-color: white;
}
</style>
